import React from 'react';

export function PictoChinese40() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_840_900)">
        <path
          d="M5.26625 12.2364C5.12459 11.0465 6.05393 10 7.25222 10H32.7478C33.9461 10 34.8754 11.0465 34.7338 12.2364L31.8766 36.2364C31.7569 37.2424 30.9038 38 29.8906 38H10.1094C9.09625 38 8.24315 37.2424 8.12339 36.2364L5.26625 12.2364Z"
          fill="#DAD8D2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.7478 11H7.25222C6.65308 11 6.18841 11.5233 6.25923 12.1182L9.11638 36.1182C9.17626 36.6212 9.60281 37 10.1094 37H29.8906C30.3972 37 30.8238 36.6212 30.8836 36.1182L33.7408 12.1182C33.8116 11.5233 33.3469 11 32.7478 11ZM7.25222 10C6.05393 10 5.12459 11.0465 5.26625 12.2364L8.12339 36.2364C8.24315 37.2424 9.09625 38 10.1094 38H29.8906C30.9038 38 31.7569 37.2424 31.8766 36.2364L34.7338 12.2364C34.8754 11.0465 33.9461 10 32.7478 10H7.25222Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.57268 11.7405C5.71599 11.5045 6.02352 11.4293 6.25956 11.5726L20.0001 19.9151L33.7406 11.5726C33.9766 11.4293 34.2842 11.5045 34.4275 11.7405C34.5708 11.9766 34.4956 12.2841 34.2596 12.4274L20.2596 20.9274C20.1001 21.0242 19.9 21.0242 19.7406 20.9274L5.74058 12.4274C5.50454 12.2841 5.42937 11.9766 5.57268 11.7405Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.55268 37.2236C8.42918 36.9766 8.52929 36.6763 8.77629 36.5528L19.7763 31.0528C19.917 30.9824 20.0827 30.9824 20.2235 31.0528L31.2235 36.5528C31.4705 36.6763 31.5706 36.9766 31.4471 37.2236C31.3236 37.4706 31.0233 37.5707 30.7763 37.4472L19.9999 32.059L9.2235 37.4472C8.97651 37.5707 8.67617 37.4706 8.55268 37.2236Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 20C20.2761 20 20.5 20.2239 20.5 20.5V31.5C20.5 31.7761 20.2761 32 20 32C19.7239 32 19.5 31.7761 19.5 31.5V20.5C19.5 20.2239 19.7239 20 20 20Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 2C11 1.72386 11.2239 1.5 11.5 1.5H29C29.2761 1.5 29.5 1.72386 29.5 2V10C29.5 10.2761 29.2761 10.5 29 10.5C28.7239 10.5 28.5 10.2761 28.5 10V2.5H12V10C12 10.2761 11.7761 10.5 11.5 10.5C11.2239 10.5 11 10.2761 11 10V2Z"
          fill="#142138"
        />
      </g>
      <defs>
        <clipPath id="clip0_840_900">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PictoChinese56() {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_840_907)">
        <path
          d="M7.26625 16.2364C7.12459 15.0465 8.05393 14 9.25222 14H46.7478C47.9461 14 48.8754 15.0465 48.7338 16.2364L44.5433 51.4364C44.4235 52.4424 43.5704 53.2 42.5573 53.2H13.4427C12.4296 53.2 11.5765 52.4424 11.4567 51.4364L7.26625 16.2364Z"
          fill="#DAD8D2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.7478 15H9.25222C8.65308 15 8.18841 15.5233 8.25923 16.1182L12.4497 51.3182C12.5096 51.8212 12.9361 52.2 13.4427 52.2H42.5573C43.0639 52.2 43.4904 51.8212 43.5503 51.3182L47.7408 16.1182C47.8116 15.5233 47.3469 15 46.7478 15ZM9.25222 14C8.05393 14 7.12459 15.0465 7.26625 16.2364L11.4567 51.4364C11.5765 52.4424 12.4296 53.2 13.4427 53.2H42.5573C43.5704 53.2 44.4235 52.4424 44.5433 51.4364L48.7338 16.2364C48.8754 15.0465 47.9461 14 46.7478 14H9.25222Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.97258 16.5405C8.11589 16.3045 8.42342 16.2293 8.65946 16.3726L28 28.1151L47.3405 16.3726C47.5765 16.2293 47.8841 16.3045 48.0274 16.5405C48.1707 16.7766 48.0955 17.0841 47.8595 17.2274L28.2595 29.1274C28.1 29.2242 27.8999 29.2242 27.7405 29.1274L8.14049 17.2274C7.90444 17.0841 7.82927 16.7766 7.97258 16.5405Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.8473 52.0236C43.7238 52.2706 43.4234 52.3707 43.1764 52.2472L28 44.659L12.8236 52.2472C12.5767 52.3707 12.2763 52.2706 12.1528 52.0236C12.0293 51.7766 12.1294 51.4763 12.3764 51.3528L27.7764 43.6528C27.9172 43.5824 28.0829 43.5824 28.2236 43.6528L43.6236 51.3528C43.8706 51.4763 43.9707 51.7766 43.8473 52.0236Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 28.2C28.2761 28.2 28.5 28.4239 28.5 28.7V44.1C28.5 44.3762 28.2761 44.6 28 44.6C27.7239 44.6 27.5 44.3762 27.5 44.1V28.7C27.5 28.4239 27.7239 28.2 28 28.2Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6001 2.79999C15.6001 2.52385 15.824 2.29999 16.1001 2.29999H40.6001C40.8762 2.29999 41.1001 2.52385 41.1001 2.79999V14C41.1001 14.2761 40.8762 14.5 40.6001 14.5C40.324 14.5 40.1001 14.2761 40.1001 14V3.29999H16.6001V14C16.6001 14.2761 16.3762 14.5 16.1001 14.5C15.824 14.5 15.6001 14.2761 15.6001 14V2.79999Z"
          fill="#142138"
        />
      </g>
      <defs>
        <clipPath id="clip0_840_907">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
